import List from './List'
import Detail from './Detail'

export default {
  ReportFormsAnalysis: 'Report Forms Analysis',
  Number: 'Number',
  Area: 'Area',
  UnitNameBranch: 'Unit Name (Branch)',
  PleaseSelect: 'Please Select',
  PleaseSelectADateRange: 'Please Select A Date Range!',
  // List翻译
  List,
  // Detail翻译
  Detail,
}